var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from 'graphql-tag';
export var MintRequestStatus;
(function (MintRequestStatus) {
    MintRequestStatus["COMPLETED"] = "COMPLETED";
    MintRequestStatus["FAILED"] = "FAILED";
    MintRequestStatus["PENDING"] = "PENDING";
})(MintRequestStatus || (MintRequestStatus = {}));
export var NftType;
(function (NftType) {
    NftType["MINT_PASS"] = "MINT_PASS";
    NftType["TCG_CARD"] = "TCG_CARD";
})(NftType || (NftType = {}));
export var PaymentOrderStatus;
(function (PaymentOrderStatus) {
    PaymentOrderStatus["CANCELED"] = "CANCELED";
    PaymentOrderStatus["COMPLETED"] = "COMPLETED";
    PaymentOrderStatus["PENDING"] = "PENDING";
    PaymentOrderStatus["REFUNDED"] = "REFUNDED";
})(PaymentOrderStatus || (PaymentOrderStatus = {}));
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["MIXPAY"] = "MIXPAY";
    PaymentProvider["STRIPE"] = "STRIPE";
})(PaymentProvider || (PaymentProvider = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["BANNED"] = "BANNED";
    UserStatus["PENDING_COMPLETION"] = "PENDING_COMPLETION";
})(UserStatus || (UserStatus = {}));
export var FMintRequestFragmentDoc = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment FMintRequest on MintRequest {\n  uuid\n  status\n}\n    "], ["\n    fragment FMintRequest on MintRequest {\n  uuid\n  status\n}\n    "])));
export var FNftTcgCardFragmentDoc = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fragment FNftTcgCard on NftTcgCard {\n  ian\n  foil\n  numbering\n}\n    "], ["\n    fragment FNftTcgCard on NftTcgCard {\n  ian\n  foil\n  numbering\n}\n    "])));
export var FNftMintPassFragmentDoc = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    fragment FNftMintPass on NftMintPass {\n  type\n  stage\n}\n    "], ["\n    fragment FNftMintPass on NftMintPass {\n  type\n  stage\n}\n    "])));
export var FNftFragmentDoc = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    fragment FNft on Nft {\n  tokenId\n  nftType\n  tcgCard {\n    ...FNftTcgCard\n  }\n  mintPass {\n    ...FNftMintPass\n  }\n}\n    ", "\n", ""], ["\n    fragment FNft on Nft {\n  tokenId\n  nftType\n  tcgCard {\n    ...FNftTcgCard\n  }\n  mintPass {\n    ...FNftMintPass\n  }\n}\n    ", "\n", ""])), FNftTcgCardFragmentDoc, FNftMintPassFragmentDoc);
export var FSuccessFragmentDoc = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    fragment FSuccess on Success {\n  success\n}\n    "], ["\n    fragment FSuccess on Success {\n  success\n}\n    "])));
export var FPaymentOrderFragmentDoc = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    fragment FPaymentOrder on PaymentOrder {\n  uuid\n  userUuid\n  quantity\n  provider\n  status\n}\n    "], ["\n    fragment FPaymentOrder on PaymentOrder {\n  uuid\n  userUuid\n  quantity\n  provider\n  status\n}\n    "])));
export var FUserFragmentDoc = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    fragment FUser on User {\n  uuid\n  email\n  username\n  solanaAccountId\n}\n    "], ["\n    fragment FUser on User {\n  uuid\n  email\n  username\n  solanaAccountId\n}\n    "])));
export var UserCompleteProfileDocument = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    mutation UserCompleteProfile($input: UserCompleteProfileInput!) {\n  userCompleteProfile(input: $input) {\n    ...FSuccess\n  }\n}\n    ", ""], ["\n    mutation UserCompleteProfile($input: UserCompleteProfileInput!) {\n  userCompleteProfile(input: $input) {\n    ...FSuccess\n  }\n}\n    ", ""])), FSuccessFragmentDoc);
var defaultWrapper = function (action, _operationName, _operationType, _variables) { return action(); };
export function getSdk(client, withWrapper) {
    if (withWrapper === void 0) { withWrapper = defaultWrapper; }
    return {
        UserCompleteProfile: function (variables, requestHeaders) {
            return withWrapper(function (wrappedRequestHeaders) {
                return client.request(UserCompleteProfileDocument, variables, __assign(__assign({}, requestHeaders), wrappedRequestHeaders));
            }, 'UserCompleteProfile', 'mutation', variables);
        },
    };
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
